export default "__VITE_ASSET__zBSFbg_t__"